// src/components/styles/theme.js
export const theme = {
  colors: {
    navy: "#0a192f",
    accent: "#3d7eff",
    lightNavy: "#112240",
    slate: "#8892b0",
    lightSlate: "#a8b2d1",
    white: "#e6f1ff"
  },
  fonts: {
    sans: '"Inter", "Calibre", sans-serif',
    mono: '"Fira Mono", "SF Mono", monospace'
  },
  mediaQueries: {
    xs: "(max-width: 480px)",
    sm: "(max-width: 768px)",
    md: "(max-width: 1024px)"
  }
};